import { render, staticRenderFns } from "./sportDataCenter.vue?vue&type=template&id=598c750a&scoped=true&"
import script from "./sportDataCenter.vue?vue&type=script&lang=js&"
export * from "./sportDataCenter.vue?vue&type=script&lang=js&"
import style0 from "./sportDataCenter.vue?vue&type=style&index=0&id=598c750a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598c750a",
  null
  
)

component.options.__file = "sportDataCenter.vue"
export default component.exports